export const SLICK_TOP_CONTENT_OPTIONS = {
    slidesToShow: 5,
    slidesToScroll: 5,
    arrows: true,
    infinite: false,
    responsive: [
        {
            breakpoint: 769,
            settings: {
                slidesToShow: 4,
                slidesToScroll: 4,
                infinite: true
            }
        },
        {
            breakpoint: 577,
            settings: {
                slidesToShow: 2.5,
                slidesToScroll: 2.5,
                infinite: true
            }
        },
        {
            breakpoint: 321,
            settings: {
                slidesToShow: 1.5,
                slidesToScroll: 1,
                infinite: false
            }
        }
    ],
    nextArrow: '<div class="arrows next"></div>',
    prevArrow: '<div class="arrows prev"></div>'
};

export const SLICK_SUBSERIES_OPTIONS = {
    slidesToShow: 4,
    slidesToScroll: 4,
    arrows: true,
    infinite: false,
    responsive: [
        {
            breakpoint: 769,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 3,
            }
        },
        {
            breakpoint: 577,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 3,
            }
        },
        {
            breakpoint: 321,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 2,
            }
        }
    ],
    nextArrow: '<div class="arrows next"></div>',
    prevArrow: '<div class="arrows prev"></div>'
};

export const SLICK_OPTIONS = {
    slidesToShow: 8,
    slidesToScroll: 8,
    arrows: true,
    infinite: true,
    responsive: [
        {
            breakpoint: 769,
            settings: {
                slidesToShow: 6,
                slidesToScroll: 6,
                infinite: true
            }
        },
        {
            breakpoint: 577,
            settings: {
                slidesToShow: 4,
                slidesToScroll: 4,
                infinite: true
            }
        },
        {
            breakpoint: 321,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 3,
                infinite: true
            }
        }
    ],
    nextArrow: '<div class="arrows next"></div>',
    prevArrow: '<div class="arrows prev"></div>'
};

export const SLICK_CATEGORIES_OPTIONS = {
    slidesToShow: 5.5,
    slidesToScroll: 5,
    arrows: true,
    infinite: false ,
    responsive: [
        {
            breakpoint: 769,
            settings: {
                slidesToShow: 4.5,
                slidesToScroll: 4,
            }
        },
        {
            breakpoint: 577,
            settings: {
                slidesToShow: 4.5,
                slidesToScroll: 4,
            }
        },
        {
            breakpoint: 321,
            settings: {
                slidesToShow: 3.5,
                slidesToScroll: 3,
            }
        }
    ],
    nextArrow: '<div class="arrows next"></div>',
    prevArrow: '<div class="arrows prev"></div>'
};